export * from "./patient.component";
export * from "./patient-tabs/patient-tabs.component";
export * from "./messaging/messaging.component";
export * from "./clinical-info/clinical-info.component";
